import { render, staticRenderFns } from "./getNew.vue?vue&type=template&id=13011855&"
import script from "./getNew.vue?vue&type=script&lang=js&"
export * from "./getNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports